import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { ELEMENTS_GUI_FIELDS } from "./elements.settings";

export const X_IMAGE_GUI_FIELDS: TXGUISection = {
  Général: [
    {
      type: "image",
      name: "src",
      label: "Choisir l'Image",
    },
    {
      type: "text",
      name: "alt",
      label: "Texte Alternatif",
    },
    {
      type: "toggle_option",
      name: "objectFit",
      label: "Mode",
      options: [
        { value: "cover", label: "Zoomer" },
        { value: "contain", label: "Ajuster" },
        { value: "fill", label: "Etirer" },
      ],
      defaultValue: "cover",
    },
  ],

  ...ELEMENTS_GUI_FIELDS,
};
